import React from 'react';

const QuizIntroSlideContent = ({ t, nameField, slideValues, slideCode, handleValueChange }) => {
  return (
    <div className="t-flex t-flex-col t-mt-8">
      <h2 className="t-font-serif t-text-[28px] sm:t-text-[38px] t-leading-[1.05] t-text-navy t-mb-4 t-m-0">
        {t('Quiz_Intro_Title')}
      </h2>
      <p className="t-text-base sm:t-text-lg t-leading-[1.3] t-text-g500 t-m-0 t-mb-7">{t('Quiz_Intro_Subtitle')}</p>

      <div className="t-flex t-flex-wrap t-gap-2 t-mb-7">
        <span className="t-inline-flex t-items-center t-rounded-full t-bg-[#E6F2EE] t-text-[#0F6E56] t-font-semibold t-px-2 md:t-px-4 t-py-2.5 t-text-xs md:t-text-sm">
          {t('Quiz_Intro_Chip_Goals')}
        </span>
        <span className="t-inline-flex t-items-center t-rounded-full t-bg-[#E6F2EE] t-text-[#0F6E56] t-font-semibold t-px-2 md:t-px-4 t-py-2.5 t-text-xs md:t-text-sm">
          {t('Quiz_Intro_Chip_Lifestyle')}
        </span>
        <span className="t-inline-flex t-items-center t-rounded-full t-bg-[#E6F2EE] t-text-[#0F6E56] t-font-semibold t-px-2 md:t-px-4 t-py-2.5 t-text-xs md:t-text-sm">
          {t('Quiz_Intro_Chip_Health')}
        </span>
      </div>

      {nameField && (
        <input
          type="text"
          id={nameField.name}
          placeholder={t('Quiz_Intro_NamePlaceholder')}
          value={slideValues[slideCode]?.[nameField.name]?.value ?? ''}
          onChange={(e) => handleValueChange(nameField, nameField.name, e.target.value)}
          className="t-w-full t-py-3.5 t-px-4 t-border-2 t-border-g200 t-rounded-xl t-font-sans t-text-base t-text-navy t-bg-white t-outline-none focus:t-border-quiz-teal placeholder:t-text-g300 t-mb-3"
          autoFocus
        />
      )}
    </div>
  );
};

export default QuizIntroSlideContent;
